<template>
  <v-btn
    :small="$vuetify.breakpoint.mobile ? true : small"
    :large="$vuetify.breakpoint.mobile ? false : xLarge"
    :block="block"
    :loading="load"
    :text="typeButton === 'text'"
    :outlined="typeButton === 'outlined'"
    :class="className"
    @click="$emit('click')"
    :color="colorBtn !== null ? colorBtn : 'secondary'"
    :disabled="disabled"
    class="rounded-0"
    :dark="dark"
    :type="submit ? 'submit' : undefined"
  >
    {{ text }}
    <v-icon v-if="icon && !alignIcon">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
const props = {
  text: String,
  onClick: Function,
  icon: String,
  colorBtn: {
    default: null,
    type: String,
  },
  typeButton: {
    default: "",
    type: String,
  },
  alignIcon: {
    default: false,
    type: Boolean,
  },
  load: {
    default: false,
    type: Boolean,
  },
  disabled: {
    default: false,
    type: Boolean,
  },
  block: {
    default: false,
    type: Boolean,
  },
  small: {
    default: false,
    type: Boolean,
  },
  xLarge: {
    default: false,
    type: Boolean,
  },
  className: {
    default: "",
    type: String,
  },
  changeIcon: {
    default: 700,
    type: Number,
  },
  dark: {
    default: false,
    type: Boolean,
  },
  submit: {
    default: false,
    type: Boolean,
  },
};

export default {
  methods: {
    execute() {
      if (this.onClick) {
        this.onClick();
      }
    },
  },
  props: props,
};
</script>

<style scoped></style>
